import React from 'react';

import clsx from 'clsx';
import {
    sectionStatusDot,
    sectionStatusDotActive,
    sectionStatusDotScheduled,
    sectionStatusLabel,
    sectionStatusLabelActive,
    sectionStatusLabelScheduled,
} from 'src/modules/profile/account/tabs/account-profile/product-access-summary-section/product-access-summary-section.module.styl';
import {ProductSubscriptionLifecycleStatus} from 'src/openapi/admin/models/ProductSubscriptionLifecycleStatus';
import {SeatAssignmentStatus} from 'src/openapi/admin/models/SeatAssignmentStatus';


const STATUS_CONFIG = {
    [ProductSubscriptionLifecycleStatus.ACTIVE]: {
        label: 'Active',
        dotClass: sectionStatusDotActive,
        labelClass: sectionStatusLabelActive,
    },
    [ProductSubscriptionLifecycleStatus.PENDING]: {
        label: 'Pending',
        dotClass: sectionStatusDotScheduled,
        labelClass: sectionStatusLabelScheduled,
    },
} as const;

type Props = {status?: ProductSubscriptionLifecycleStatus};

export const ProductAccessTermStatus: React.FC<Props> = ({status}) => {
    const statusConfig = status ? STATUS_CONFIG[status as keyof typeof STATUS_CONFIG] : null;

    return statusConfig ? (
        <>
            <span className={clsx(sectionStatusDot, statusConfig.dotClass)}/>
            <span className={clsx(sectionStatusLabel, statusConfig.labelClass)}>{statusConfig.label}</span>
        </>
    ) : <span>{status || '--'}</span>;
};

type SeatStatusProps = {status: SeatAssignmentStatus};

export const SeatAssignmentStatusLabel: React.FC<SeatStatusProps> = ({status}) => (
    <>
        <span className={clsx(sectionStatusDot, status === SeatAssignmentStatus.ACTIVE ? sectionStatusDotActive : '')}/>
        <span className={clsx(sectionStatusLabel, status === SeatAssignmentStatus.ACTIVE ? sectionStatusLabelActive : '')}>
            {status.charAt(0)}{status.slice(1).toLowerCase()}
        </span>
    </>
);
